import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-md bg-muted relative overflow-hidden",
        "before:absolute before:inset-0",
        "before:bg-gradient-to-r before:from-transparent before:via-neon-purple/10 before:to-transparent",
        "before:animate-skeleton-fuel-shimmer",
        className
      )}
      {...props}
    />
  );
}

// Fuel-themed skeleton for video cards
function SkeletonVideoCard({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "aspect-[9/16] rounded-xl bg-muted relative overflow-hidden border border-white/10",
        className
      )}
      {...props}
    >
      {/* Fuel pump filling animation */}
      <div className="absolute bottom-0 left-0 right-0 animate-fuel-fill-skeleton">
        <div className="h-full bg-gradient-to-t from-neon-purple/20 via-neon-pink/10 to-transparent" />
      </div>
      
      {/* Shimmer overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent animate-skeleton-fuel-shimmer" />
      
      {/* Placeholder content */}
      <div className="absolute top-3 left-3 right-3 flex items-center gap-2">
        <div className="w-9 h-9 rounded-full bg-white/10" />
        <div className="flex-1 space-y-1.5">
          <div className="h-3 w-24 rounded bg-white/10" />
          <div className="h-2 w-16 rounded bg-white/5" />
        </div>
      </div>
      
      <div className="absolute bottom-3 left-3 right-3 space-y-2">
        <div className="h-3 w-full rounded bg-white/10" />
        <div className="h-3 w-3/4 rounded bg-white/5" />
      </div>
    </div>
  );
}

// Loading text with animated dots
function SkeletonText({ text = "Fueling up", className }: { text?: string; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-0.5", className)}>
      {text}
      <span className="animate-loading-dot-1">.</span>
      <span className="animate-loading-dot-2">.</span>
      <span className="animate-loading-dot-3">.</span>
    </span>
  );
}

export { Skeleton, SkeletonVideoCard, SkeletonText };
